import React from 'react';
import PropTypes from 'prop-types';

import MarketingMaterialSample from './MarketingMaterialSample';
import withModal from '../../../../../../components/global/modal/withModal';

export const MARKETING_MATERIAL_SAMPLE_MODAL =
  'modal/MARKETING_MATERIAL_SAMPLE_MODAL';

const propTypes = {
  actionProps: PropTypes.shape({
    previewUrl: PropTypes.string,
    label: PropTypes.string,
  }),
};

const MarketingMaterialSampleModal = ({
  actionProps: { previewUrl, label } = {},
  ...props
}) => {
  return (
    <MarketingMaterialSample {...props} previewUrl={previewUrl} label={label} />
  );
};

MarketingMaterialSampleModal.propTypes = propTypes;

export default withModal(MarketingMaterialSampleModal, {
  name: MARKETING_MATERIAL_SAMPLE_MODAL,
  size: 'sm',
});
